
import {Component, Vue} from "vue-property-decorator";
import {Action, Getter} from "vuex-class";
import {EICRAPRO_BEKLENIYOR_MESAJI, eicraproBekleniyorHatasiMi} from "@/utils/eicraproBaglantisi";

@Component
export default class UyapConnectionInfo extends Vue {
  @Getter isUyapConnected!: boolean;
  @Getter isDevMode!: boolean;
  @Action connectToUyap!: () => Promise<void>;
  @Getter isTokenExis!: boolean;

  get iconColor(): string {
    return this.isUyapConnected ? 'green' : 'white';
  }

  get tooltipText(): string {
    if (this.isUyapConnected) return 'UYAP Bağlantısını yenile.';
    return this.isTokenExis ? "Uyap'a Bağlan" : 'eİcraPro bağlantısı bekleniyor';
  }

  handleAction(): void {
    if (this.isUyapConnected) {
      this.openUyap();
    } else {
      // Hata durumu store'da uyapStatusMessage olarak gösteriliyor;
      // burada sadece unhandled rejection engellenir.
      this.connectToUyap().catch((e: unknown) => {
        if (eicraproBekleniyorHatasiMi(e)) {
          this.$toast.info(EICRAPRO_BEKLENIYOR_MESAJI);
          return;
        }
        console.error('UYAP bağlantısı başarısız.', e);
      });
    }
  }

  openUyap(): void {
    this.$store.dispatch('openUyapWindow');
  }
}
